import { addSuccessSection } from "api/Finances";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";


export const useStoreSuccess = () => {
    const queryClient = useQueryClient();
    return useMutation(addSuccessSection, {
        onSuccess: () => {
            toast.success("Section added sucesfully");
            queryClient.invalidateQueries('monthlySuccess');
        },
        onError: () => {
            toast.error("Something went wrong! Please try again later.");
        },
    })
}